<template>
    <div class="subscription-footer">
        <div class="main-container" :class="{ 'flex-between-wrapper': withOption }">
		  <img class="footer-picture" src="/assets/app/class/reading-compre-bg.png" v-if="withOption">
          <div class="main-content" :class="{ 'with-option': withOption }">
            <a href="/"><rt-picture class="footer-img" src="/assets/app/class/icon-logo-white.svg"></rt-picture></a>
            <h3 class="title-improve">Improve your students’</h3>
            <h3 class="title-reading">Reading Comprehension.</h3>
            <p class="footer-description">Personalized reading comprehension exercises for K-12 and ESL students.</p>
            <primary-button class="btn-choose-plan" @click="handleClickChoose">Choose Your Plan</primary-button>
          </div>
        </div>
    </div>
</template>

<script>
import RtPicture from '../../common/Picture.vue';
import PrimaryButton from '../../common/PrimaryButton.vue';

export default {
  props: {
	withOption: Boolean
  },
  components: {
    RtPicture,
    PrimaryButton
  },
  methods: {
    handleClickChoose() {
      $("html, body").animate({ scrollTop: 81 }, "slow");
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/variables';

.subscription-footer {
  background: #142035;
  padding-top: 96px;
  padding-bottom: 206px;
  .footer-picture {
	margin-right: 80px;
  }
  .title-improve, .title-reading {
    line-height: 1.3;
    font-family: $title-font;
    font-weight: 700;
    font-size: 48px;
    color: #fff;
  }
  .title-improve {
    padding-top: 48px;
  }
  .title-reading {
    color: $light-yellow;
  }
  .footer-description {
    margin-top: 12px;
    font-size: 20px;
    color: #fff;
  }
  .btn-choose-plan {
    background: $light-red;
	margin-top: 48px;
	padding: 16px 49px;
    border: 2px solid #FFFFFF;
    border-radius: 30px;
  }
  .main-container {
	max-width: 1170px;
    margin: 0 auto;
    text-align: left;
	.main-content {
	  &.with-option {
		text-align: left;
	    p, h3 {
		  text-align: left;
		}
		.btn-choose-plan {
		  border: 0;
		}
	  }
	}
  }
  @media(max-width: 960px) {
    .main-container {
      flex-wrap: wrap;
    }
  }
  @media(max-width: 900px) {
    padding: 50px 0;
    .title-improve, .title-reading {
      font-size: 32px;
    }
    .title-improve {
      padding-top: 30px;
    }
    .footer-description {
      font-size: 16px;
    }
    .btn-choose-plan {
      margin-top: 30px;
    }
  }
  @media(max-width: 767px) {
	.footer-picture {
    max-width: 100%;
	  margin-right: 0;
	  margin-bottom: 60px;
	}
  }
  @media(max-width: 470px) {
	  .footer-picture {
      width: 100%;
    }
	}
  @media(max-width: 418px) {
    .title-improve, .title-reading {
      font-size: 24px;
    }
    .footer-img {
      width: 100%;
    }
    .footer-description {
      font-size: 12px;
    }
  }
}
</style>